'use client';

import { BotyThemeProvider, ToastProvider } from '@boty/ui';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import { AdminShell } from '../../features/layout/AdminShell';
import { PostHogProvider } from '../../providers/PostHogProvider';

export function AdminProviders({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000, // 1 minute
          },
        },
      })
  );

  return (
    <QueryClientProvider client={queryClient}>
      <BotyThemeProvider>
        <ToastProvider>
          <PostHogProvider>
            <AdminShell>{children}</AdminShell>
          </PostHogProvider>
        </ToastProvider>
      </BotyThemeProvider>
    </QueryClientProvider>
  );
}
